export function HXConnectCarousel(props: any) {
  const handleClick = () => {
    window.open("https://asknow.service-now.com/esc", "_blank", "noreferrer");
  };
  const isUser = props?.profileData?.oracle?.employee?.first_name;
  return (
    <div
      className="card border-0 mb-0 pb-0"
      onClick={isUser ? handleClick : undefined}
      style={{ cursor: isUser ? "pointer" : "default" }}
    >
      <img
        src={props.web_url}
        className="w-100 img-fluid desktopImage"
        alt="HXconnect"
      />
      <img
        src={props.mobile_url}
        className="w-100 img-fluid mobileImage"
        alt="HXconnect"
      />
      <div className="card-img-overlay text-start">
        <div className="row mb-4">
          <div className="col-md-12 pt-3">
            {props?.profileData?.oracle?.employee?.first_name ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="text-end">
                      Do you have any question related to Human Resources?
                    </h2>
                  </div>
                </div>

                <div className="row position-absolute bottom-0 end-0 mb-3 me-4">
                  <div className="col-md-12">
                    <p className="text-end">
                      Visit{" "}
                      <a
                        href="https://asknow.service-now.com/esc"
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        HXconnect
                      </a>{" "}
                      or contact the Human <br /> Capital representative for
                      your site.
                    </p>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
